/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizsetSearchReqOrder = typeof QuizsetSearchReqOrder[keyof typeof QuizsetSearchReqOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizsetSearchReqOrder = {
  RECENTLY: 'RECENTLY',
  POPULARITY: 'POPULARITY',
  DAILY_POPULARITY: 'DAILY_POPULARITY',
  WEEKLY_POPULARITY: 'WEEKLY_POPULARITY',
  MONTHLY_POPULARITY: 'MONTHLY_POPULARITY',
} as const;
